
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { captureAttribution } from './utils/attribution'
import { initAnalytics } from './utils/analytics'
import './index.css'
import './styles/auth-cool-linen.css'

// Before render: the OAuth handoff from /signin navigates client-side and
// discards the query string, so the fallback read has to happen at boot.
captureAttribution()
initAnalytics()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)